import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core/services/auth.service';
import { SidebarService } from 'src/app/core/services/sidebar.service';
import { SidebarGroup } from '../../models/sidebarGroup';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UserEditModalComponent } from 'src/app/core/components/auth/user-edit-modal/user-edit-modal.component';
import { EntityPanelService } from '../../services/entity-panel.service';
import { getStoredToken } from 'src/app/core/utils/auth-storage';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: false,
  providers: [DialogService] // Importante prover o serviço aqui
})
export class SidebarComponent implements OnInit, OnDestroy {
  @Input() sidebarTitle: string = 'ConnectSea';
  @Input() moduleLogo: string = '../../../../assets/img/connect-sea/favicon-connectsea.png';
  @Input() menuGroups: SidebarGroup[] = [];
  @Input() currentModule: string = '';

  currentUser: any = null;
  isUserMenuOpen = false;
  isCollapsed = false;
  isHomeMode = false;

  ref: DynamicDialogRef | undefined; // Referência para o modal

  private subs: Subscription = new Subscription();

  constructor(
    private router: Router,
    private authService: AuthService,
    private sidebarService: SidebarService,
    public dialogService: DialogService,
    private entityPanelService: EntityPanelService,
  ) {}

  openEntityPanel(): void {
    this.entityPanelService.open(this.currentModule);
  }

  ngOnInit(): void {
    this.subs.add(
      this.sidebarService.isCollapsed$.subscribe((collapsed) => {
        this.isCollapsed = this.isHomeMode ? true : collapsed;
        this.isUserMenuOpen = false;
      })
    );

    if (!this.menuGroups || this.menuGroups.length === 0) {
      this.isHomeMode = true;
      this.sidebarService.setCollapsed(true);
    } else {
      this.isHomeMode = false;
    }

    this.subs.add(
      this.authService.currentUser$.subscribe((user) => {
        this.currentUser = user;
      })
    );

    this.loadUserFromStorage();
  }

  loadUserFromStorage() {
    if (!this.currentUser) {
      const userStr = this.authService.getUserFromStorage();
      if (userStr) {
        try {
          const parsed = JSON.parse(userStr);
          this.currentUser = parsed.user ? parsed : { user: parsed };
        } catch (e) { console.error(e); }
      }
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    if (this.ref) this.ref.close();
  }

  get displayName(): string {
    const token = getStoredToken();
    if (token) {
      const decoded = this.authService.getDecodedToken(token);
      if (decoded?.DisplayName) return decoded.DisplayName;
      if (decoded?.displayName) return decoded.displayName;
    }
    return this.currentUser?.user?.userName || this.currentUser?.userName || 'Usuário';
  }

  toggleSidebar() {
    if (this.isHomeMode) return;
    this.sidebarService.toggle();
  }

  toggleGroup(group: SidebarGroup) {
    if (group.isFixed) return;
    group.isExpanded = !group.isExpanded;
  }

  toggleUserMenu() {
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  logout() {
    this.isUserMenuOpen = false;
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  // --- NOVA CHAMADA DO MODAL BONITO ---
  openEditProfile() {
    this.isUserMenuOpen = false; // Fecha o menu flutuante

    // Prepara dados atuais
    const user = this.currentUser?.user || this.currentUser;
    const data = {
        email: user.email,
        displayName: this.displayName // Usa o getter inteligente
    };

    // Abre modal igual ao Voucher
    this.ref = this.dialogService.open(UserEditModalComponent, {
      showHeader: false, // Esconde header padrão do PrimeNG para usar o nosso customizado
      width: '500px',
      contentStyle: { overflow: 'visible', padding: '0', borderRadius: '12px' },
      baseZIndex: 10000,
      closable: true,
      data: data,
    });

    // Ao fechar (se salvou, o AuthService já atualizou o observable, então o nome atualiza sozinho)
    this.ref.onClose.subscribe((result: any) => {
       // Lógica extra se necessário
    });
  }
}
